module.exports = __webpack_public_path__ + "static/10-abd8d1300c5d1433528ca15c498cae70.mp4";